import { render } from "./uploadModal.vue?vue&type=template&id=d5a63cea&scoped=true"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"

import "./uploadModal.vue?vue&type=style&index=0&id=d5a63cea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a63cea"]])

export default __exports__